// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__BCW63","fill":"Loader_fill__rbflP","touch":"Loader_touch__LRsXU","transparent":"Loader_transparent__f9qV+"};